export default "__VITE_ASSET__bc262bbc__"